import styled from 'styled-components';

export const SWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const SIcon = styled.i`
  margin-right: 22px;
  font-size: 17px;
`;

export const SContent = styled.div`
  flex: 1;
  font-size: 15px;
  word-break: break-word;
  overflow-y: auto;
  max-height: 600px;
`;

export const SCloseIcon = styled.i`
  margin-left: 22px;
  font-size: 13px;
`;
